import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";


export default function Upwork() {
  const { t } = useTranslation();

  return (
    <div className="page-wrapper">      
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        <div className="big-title">{t("upworkTitle")}</div>

        <img
          src="/projects/upwork.webp"
          alt="Upwork"
          className="project-image"
        />

        <div className="porfolio-project-text-wrapper">
          <p className="section-content-unbounded">
            {t("upworkDescriptionShort")}
          </p>

            <p className="section-content-unbounded">
            {t("upworkLinkLabel")}{" "}
            <a
              href="https://upwork.com/freelancers/~01c455ecf87be6b791"
              target="_blank"
              rel="noopener noreferrer"
              className="project-link"
            >
              {t("upworkLinkText")}↗
            </a>
          </p>      

          <p className="section-content-unbounded">
            {t("upworkDescriptionLong")}
          </p>
        </div>

        <div className="cta-button-secondary-wrapper-bottom">
          <Link 
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("upworkPage")}
          >
            {t("ctaBookCall")}
          </Link>
        </div>                
        <Footer />           
      </div>
    </div>
    
  );
}
